import { render, staticRenderFns } from "./RevenueWarning.vue?vue&type=template&id=057141a2&scoped=true"
import script from "./RevenueWarning.vue?vue&type=script&lang=js"
export * from "./RevenueWarning.vue?vue&type=script&lang=js"
import style0 from "./RevenueWarning.vue?vue&type=style&index=0&id=057141a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057141a2",
  null
  
)

export default component.exports